var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#374151",
  d: "M5.003 22h14c1.103 0 2-.897 2-2v-9a1 1 0 0 0-.293-.707l-8-8a1 1 0 0 0-1.414 0l-8 8a1 1 0 0 0-.293.707v9c0 1.103.897 2 2 2m5-2v-5h4v5zm-5-8.586 7-7 7 7V20h-3v-5c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v5h-3z"
})));
export default SvgHome;